export default __webpack_public_path__ + "static/img-point-third-72c075424088d9344397f2b61b8e2770.avif";